/**
 * GreetingSection Component
 * Displays personalized greeting with compassionate context based on user's journey
 */

import React from 'react';

const GreetingSection = ({ userFirstName, childName, journeyStage, profileComplete }) => {
  // Get time-based greeting
  const getTimeGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 10) return 'God morgen';
    if (hour < 18) return 'Hei';
    return 'God kveld';
  };

  // Get compassionate context line based on journey stage
  const getContextLine = () => {
    if (!profileComplete) {
      return 'La oss komme i gang med å finne den hjelpen dere trenger.';
    }

    switch (journeyStage) {
      case 'new':
        return `Vi er her for å hjelpe dere navigere rettigheter og søknader for ${childName}.`;

      case 'started_application':
        return 'Du er godt i gang. La oss fullføre søknaden sammen.';

      case 'application_ready':
        return 'Søknaden din er klar! Neste steg er å sende den til Nav.';

      case 'application_submitted':
        return 'Søknaden er sendt. I mellomtiden kan vi se på andre rettigheter dere har krav på.';

      case 'exploring_next':
        return 'Du har allerede kommet langt. La oss se hva mer dere kan søke om.';

      default:
        return `Vi hjelper deg navigere rettigheter og søknader for ${childName}.`;
    }
  };

  return (
    <div className="mb-8 animate-fade-in">
      <h1 className="font-display text-3xl font-semibold text-text-primary mb-2">
        {userFirstName ? `${getTimeGreeting()}, ${userFirstName}` : getTimeGreeting()}
      </h1>
      <p className="text-lg text-text-secondary">
        {getContextLine()}
      </p>
    </div>
  );
};

export default GreetingSection;
